import { render, staticRenderFns } from "./BrbCard.vue?vue&type=template&id=60f55c58&"
import script from "./BrbCard.vue?vue&type=script&lang=js&"
export * from "./BrbCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f55c58')) {
      api.createRecord('60f55c58', component.options)
    } else {
      api.reload('60f55c58', component.options)
    }
    module.hot.accept("./BrbCard.vue?vue&type=template&id=60f55c58&", function () {
      api.rerender('60f55c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbCard.vue"
export default component.exports